var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZeusBoltBlackOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-4 -4 247 389",
    width: 247,
    height: 389,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB56",
    stroke: "#000000",
    strokeWidth: 6,
    strokeLinejoin: "round",
    d: "M121,3 H230 Q241,3 236,13 L186,102 Q180,122 195,122 H230 Q241,122 235,134 L92,372 Q85,382 77,380 Q70,377 70,368 V214 Q70,205 61,205 H9 Q0,205 3,189 L116,7 Q118,3 121,3 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeusBoltBlackOutline);
export default __webpack_public_path__ + "static/media/zeus_bolt_black_outline.60455d891671a981b03e809827b072f1.svg";
export { ForwardRef as ReactComponent };